import { Button, Col, Form, Modal } from "react-bootstrap";
import { ButtonRemover, ButtonTrash, JRow, JTable, JTBody, JTHead } from "../../../../components/Components";
import { LacUnidCargaInterface, SelectObjectRemoveInterface } from "../../../../interfaces";
import { useRef, useState } from "react";
import { getUuidV4, goToFocus } from "../../../../utils/utils";
import { useQuestion } from "../../../../components/ModalQuestion/useModalQuestion";
import { useModalMessage } from "../../../../components/ModalMessage/useModalMessage";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../../app/store";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDoorClosed } from "@fortawesome/free-solid-svg-icons";
import {
    addLacreUnidadeCargaUnidadeTransporteMDFe, removeLacreUnidadeCargaUnidadeTransporteMDFe,
    removeLacreUnidadeCargaUnidadeTransporteMDFeTodos
} from "../../../../features/manifestoSlice";

interface formProps {
    id: number | string;
    idUndCarga: number | string;
    idMDFe: number | string;
    show: boolean;
    handleClose: () => void;
}

const MDFesUnidadeTranspUnidadeCargaLacres: React.FC<formProps> = ({ id, idUndCarga, idMDFe, show, handleClose }) => {
    const [numeroLacre, setNumeroLacre] = useState<string>('');
    const numeroLacreRef = useRef<HTMLInputElement>(null);
    const { confirm, ConfirmModal } = useQuestion();
    const { alertModal, ModalMessageEl } = useModalMessage();
    const dispatch = useDispatch();
    const [selecionado, setSelecionado] = useState<number | string>('');
    const lacres = useSelector((state: RootState) => state.manifesto.manifesto).infMunDescarga
        .flatMap(mun => mun.infMDFe).filter(nfe => nfe?.id?.toString() === idMDFe.toString())
        .flatMap(ut => ut?.infUnidTransp).filter(f => f?.id.toString() === id.toString())
        .flatMap(ut => ut?.infUnidCarga ?? []).filter(i => i.id.toString() === idUndCarga.toString())
        .flatMap(l => l?.lacUnidCarga)
        ;

    const validaPreenchimento = () => {
        if (numeroLacre.trim() === "") {
            goToFocus(numeroLacreRef)
            alertModal('Informe o número do lacre.');
            return false;
        }

        if (lacres.find(item => item?.nLacre.toString() === numeroLacre.toString())) {
            alertModal(`O lacre ${numeroLacre.trim()} já foi adicionado.`);
            goToFocus(numeroLacreRef)
            return false;
        }

        return true;
    }

    const handleAdd = () => {
        if (validaPreenchimento()) {
            dispatch(addLacreUnidadeCargaUnidadeTransporteMDFe({
                idUnidadeCarga: idUndCarga,
                mdfeId: idMDFe,
                idUnidadeTransprte: id,
                lacre: {
                    id: getUuidV4(),
                    nLacre: numeroLacre
                }
            }))
            setNumeroLacre('');
            goToFocus(numeroLacreRef)
        }
    }

    const handleRemover = async (value: SelectObjectRemoveInterface) => {
        setSelecionado(value.id);
        
        const confirmed = await confirm({
            message: <>Deseja realmente remover <strong>{value.title}</strong> ?</>,
            title: "Confirmação"
        });
        if (confirmed) {
            dispatch(removeLacreUnidadeCargaUnidadeTransporteMDFe({
                idLacre: value.id,
                idUnidadeCarga: idUndCarga,
                idUnidadeTransprte: id,
                mdfeId: idMDFe
            }))
        }
        setSelecionado('');
    }

    const handleRemoverTodos = async () => {
        if (lacres.length > 0) {
            const confirmed = await confirm({
                message: <>Remover todos os lacres ?</>,
                title: "Confirmação",
            });
            if (confirmed) {
                dispatch(removeLacreUnidadeCargaUnidadeTransporteMDFeTodos({
                    idUnidadeCarga: idUndCarga,
                    idUnidadeTransprte: id,
                    mdfeId: idMDFe
                }))
            }
        }
    }

    return (<>
        <Modal show={show} onHide={handleClose} centered backdrop='static' fullscreen={'xl-down'} scrollable >
            <Modal.Header closeButton className="py-2">
                <Modal.Title >
                    Lacres
                </Modal.Title>

            </Modal.Header>
            <Modal.Body>
                <JRow className="mb-3 ">
                    <Col md>
                        <Form.Group controlId="mdfe-utlc-numeroLacre">
                            <Form.Label>Número do lacre</Form.Label>
                            <Form.Control type="text" value={numeroLacre}
                                name="numeroLacre"

                                ref={numeroLacreRef}
                                placeholder="Digite o número + [Enter] para adicionar"
                                onChange={(e) => setNumeroLacre(e.target.value)}
                                onKeyUp={(e) => {
                                    if (e.key === 'Enter') {
                                        handleAdd();
                                    }
                                }}
                            />
                        </Form.Group>
                    </Col>

                    <JTable>
                        <JTHead >
                            <tr>
                                <th className="text-center" style={{ width: '4.5rem' }}>
                                    <ButtonTrash onClick={() => handleRemoverTodos()} />
                                </th>
                                <th>Número do lacre</th>
                            </tr>
                        </JTHead>
                        <JTBody>
                            {lacres.map((item: LacUnidCargaInterface) => {
                                return (
                                    <tr key={item?.id}
                                        className={(item?.id?.toString()) === selecionado.toString() ? 'table-danger' : ''}>
                                        <td className="text-center">
                                            <ButtonRemover
                                                onClick={() => handleRemover({ id: item.id, title: item.nLacre })} />
                                        </td>
                                        <td>
                                            {item.nLacre}
                                        </td>
                                    </tr>
                                )
                            })
                            }

                        </JTBody>
                    </JTable>
                </JRow>

            </Modal.Body>
            <Modal.Footer className="py-2">
                <Button variant="secondary" onClick={handleClose} >
                    <FontAwesomeIcon icon={faDoorClosed} /> Fechar
                </Button>
            </Modal.Footer>
            {ConfirmModal}
            {ModalMessageEl}
        </Modal >
    </>)
}

export default MDFesUnidadeTranspUnidadeCargaLacres;